import { api, SITE_URL } from "@/lib/api";

export const createForm = (payload) => api.post("/forms", payload).then((r) => r.data);
export const updateForm = (id, payload) => api.put(`/forms/${id}`, payload).then((r) => r.data);
export const fetchForm = (id) => api.get(`/forms/${id}`).then((r) => r.data);
export const listForms = () => api.get("/forms").then((r) => r.data);
export const deleteForm = (id) => api.delete(`/forms/${id}`).then((r) => r.data);
export const sendFormToCustomer = (id, email, origin) =>
  api.post(`/forms/${id}/send`, { email, origin }).then((r) => r.data);
export const createFormPaymentLink = (id) =>
  api.post(`/forms/${id}/payment-link`, {}).then((r) => r.data);
export const fetchParts = () => api.get("/parts").then((r) => r.data);
export const fetchCustomers = () => api.get("/customers").then((r) => r.data);
export const fetchTimeline = (cid) => api.get(`/customers/${cid}/timeline`).then((r) => r.data);
export const fetchBlogEngine = () => api.get("/admin/blog-engine").then((r) => r.data);
export const fetchSeoCommand = () => api.get("/admin/seo-command").then((r) => r.data);
export const runBlogEngine = (publish = true) => api.post("/admin/blog-engine/run", { publish }).then((r) => r.data);
export const startBlogBackfill = (opts = {}) => api.post("/admin/blog-engine/backfill", opts).then((r) => r.data);
export const fetchBlogBackfillStatus = () => api.get("/admin/blog-engine/backfill/status").then((r) => r.data);
export const fetchBlogDrafts = () => api.get("/admin/blog/drafts").then((r) => r.data);
export const publishBlogDraft = (slug) => api.post(`/admin/blog/${slug}/publish`).then((r) => r.data);
export const unpublishBlogDraft = (slug) => api.post(`/admin/blog/${slug}/unpublish`).then((r) => r.data);
export const saveSeoLocal = (payload) => api.put("/admin/seo/local", payload).then((r) => r.data);
export const createLocalPage = (service_slug, city_slug) => api.post("/admin/seo/local-page", { service_slug, city_slug }).then((r) => r.data);
export const addTimelineEntry = (cid, payload) => api.post(`/customers/${cid}/timeline`, payload).then((r) => r.data);

// Public signing link for a saved form
export const signLinkFor = (form) =>
  `${window.location.origin}/sign/${form.sign_token}`;

// ---- Requests (leads) helpers & option sets ----
export const fetchBookings = () => api.get("/leads").then((r) => r.data);
export const fetchLeadStats = () => api.get("/leads/stats").then((r) => r.data);
export const fetchTeam = () => api.get("/team").then((r) => r.data);
export const updateBooking = (id, patch) => api.patch(`/leads/${id}`, patch).then((r) => r.data);
export const deleteBooking = (id) => api.delete(`/leads/${id}`).then((r) => r.data);
export const createLead = (payload) => api.post("/leads", { ...payload, internal: true }).then((r) => r.data);
export const fetchLeadAttention = () => api.get("/leads/attention").then((r) => r.data);
export const fetchLeadRoi = (period = "all") => api.get("/leads/roi", { params: { period } }).then((r) => r.data);
export const logLeadResponse = (id, payload) => api.post(`/leads/${id}/log-response`, payload || {}).then((r) => r.data);
export const sendLeadFollowup = (id) => api.post(`/leads/${id}/follow-up`, {}).then((r) => r.data);
export const fetchSourceSpend = () => api.get("/leads/source-spend").then((r) => r.data);
export const saveSourceSpend = (map) => api.put("/leads/source-spend", { map }).then((r) => r.data);

export const STATUS_OPTIONS = [
  { value: "new", label: "New", color: "#0ea5e9" },
  { value: "contacted", label: "Contacted", color: "#a855f7" },
  { value: "scheduled", label: "Scheduled", color: "#2563eb" },
  { value: "in_progress", label: "In Progress", color: "#f59e0b" },
  { value: "completed", label: "Completed", color: "#22c55e" },
  { value: "won", label: "Won", color: "#16a34a" },
  { value: "lost", label: "Lost", color: "#ef4444" },
];

// Standardized attribution sources (kept in sync with backend LEAD_SOURCES).
export const LEAD_SOURCE_OPTIONS = [
  { value: "Google Business Profile", label: "Google Business Profile" },
  { value: "Google Search/Organic", label: "Google Search / Organic" },
  { value: "Google Ads", label: "Google Ads" },
  { value: "Facebook", label: "Facebook" },
  { value: "Instagram", label: "Instagram" },
  { value: "TikTok", label: "TikTok" },
  { value: "Website Form", label: "Website Form" },
  { value: "Phone", label: "Phone" },
  { value: "Referral", label: "Referral" },
  { value: "Existing Customer", label: "Existing Customer" },
  { value: "Realtor", label: "Realtor" },
  { value: "Property Manager", label: "Property Manager" },
  { value: "Builder/GC", label: "Builder / GC" },
  { value: "Facility Manager", label: "Facility Manager" },
  { value: "HOA/Community", label: "HOA / Community" },
  { value: "B2B Outreach", label: "B2B Outreach" },
  { value: "Direct/Walk-In", label: "Direct / Walk-In" },
  { value: "Weather Intelligence", label: "Weather Intelligence" },
  { value: "Other", label: "Other" },
  { value: "Unknown", label: "Unknown" },
];

export const OUTCOME_OPTIONS = [
  { value: "pending", label: "Pending" },
  { value: "quoted", label: "Quoted" },
  { value: "sold", label: "Sold" },
  { value: "not_sold", label: "Not Sold" },
  { value: "follow_up", label: "Follow Up" },
];

// ---- Parts catalog & memberships ----
export const createPart = (b) => api.post("/parts", b).then((r) => r.data);
export const deletePart = (id) => api.delete(`/parts/${id}`).then((r) => r.data);
export const uploadImage = async (file) => {
  const { data } = await api.post("/upload", file, { headers: { "Content-Type": file.type || "application/octet-stream" } });
  return `${process.env.REACT_APP_BACKEND_URL}${data.url}`;
};
export const fetchMemberships = () => api.get("/memberships").then((r) => r.data);
export const setCustomerMembership = (key, tier, renewal_date) =>
  api.post(`/customers/${key}/membership`, { tier, renewal_date }).then((r) => r.data);

// ---- Dispatch service jobs & Calendar appointments ----
export const listServiceJobs = () => api.get("/servicejobs").then((r) => r.data);
export const createServiceJob = (b) => api.post("/servicejobs", b).then((r) => r.data);
export const patchServiceJob = (id, patch) => api.put(`/servicejobs/${id}`, patch).then((r) => r.data);
export const listAppointments = () => api.get("/appointments").then((r) => r.data);
export const createAppointment = (b) => api.post("/appointments", b).then((r) => r.data);
export const patchAppointment = (id, patch) => api.put(`/appointments/${id}`, patch).then((r) => r.data);
export const deleteAppointment = (id) => api.delete(`/appointments/${id}`).then((r) => r.data);

// ---- LAUNCH SELECT™ (equipment, add-ons, proposals) ----
export const REQUIRED_MAINTENANCE_PLAN = "Aquila Comfort Club — Lifetime Warranty Plan";
export const fetchEquipment = () => api.get("/equipment", { params: { all: true } }).then((r) => r.data);
export const saveEquipment = (b) => api.post("/equipment", b).then((r) => r.data);
export const deleteEquipment = (id) => api.delete(`/equipment/${id}`).then((r) => r.data);
export const fetchAddons = () => api.get("/addons", { params: { all: true } }).then((r) => r.data);
export const saveAddon = (b) => api.post("/addons", b).then((r) => r.data);
export const deleteAddon = (id) => api.delete(`/addons/${id}`).then((r) => r.data);
export const fetchProposals = () => api.get("/proposals").then((r) => r.data);
export const createProposal = (b) => api.post("/proposals", b).then((r) => r.data);
export const updateProposal = (id, b) => api.put(`/proposals/${id}`, b).then((r) => r.data);
export const deleteProposal = (id) => api.delete(`/proposals/${id}`).then((r) => r.data);
export const proposalLink = (p) => `${window.location.origin}/proposal/${p.share_token}`;

// ---- Unsold Proposal Follow-Up (Feature #2) ----
export const sendProposal = (id, origin) => api.post(`/proposals/${id}/send`, { origin: origin || window.location.origin }).then((r) => r.data);
export const sendProposalFollowup = (id) => api.post(`/proposals/${id}/follow-up`, {}).then((r) => r.data);
export const logProposalResponse = (id, payload) => api.post(`/proposals/${id}/log-response`, payload || {}).then((r) => r.data);
export const proposalFollowupControl = (id, action) => api.post(`/proposals/${id}/followup-control`, { action }).then((r) => r.data);
export const fetchProposalAttention = () => api.get("/proposals/attention").then((r) => r.data);
export const fetchProposalRecovery = (period = "all") => api.get("/proposals/recovery", { params: { period } }).then((r) => r.data);

export const monthlyPayment = (principal, apr, term) => {
  const P = Number(principal) || 0, n = Number(term) || 0;
  if (!P || !n) return 0;
  const r = (Number(apr) || 0) / 100 / 12;
  if (r === 0) return P / n;
  return (P * r) / (1 - Math.pow(1 + r, -n));
};
export const money = (n) => `$${(Number(n) || 0).toLocaleString(undefined, { maximumFractionDigits: 0 })}`;

export const fetchWarrantyCompliance = () => api.get("/warranty-compliance").then((r) => r.data);
export const proposalInsights = (id) => api.post(`/proposals/${id}/insights`, {}).then((r) => r.data);


// ---- Dual Pricebook CRM (P1) ----
export const fetchPricebook = (book) =>
  api.get("/crm/pricebook", { params: book ? { book } : {} }).then((r) => r.data);
export const createPbItem = (p) => api.post("/crm/pricebook", p).then((r) => r.data);
export const updatePbItem = (id, p) => api.put(`/crm/pricebook/${id}`, p).then((r) => r.data);
export const deletePbItem = (id) => api.delete(`/crm/pricebook/${id}`).then((r) => r.data);
export const fetchPbConfig = () => api.get("/crm/pricebook/config").then((r) => r.data);
export const savePbConfig = (p) => api.put("/crm/pricebook/config", p).then((r) => r.data);
export const jaysQuote = (p) => api.post("/crm/pricebook/jays/quote", p).then((r) => r.data);
export const getJobDiagnosis = (id) => api.get(`/crm/jobs/${id}/diagnosis`).then((r) => r.data);
export const saveJobDiagnosis = (id, b) => api.post(`/crm/jobs/${id}/diagnosis`, b).then((r) => r.data);
export const fetchMatchedSystems = (params) => api.get("/crm/equipment/matched-systems", { params }).then((r) => r.data);
export const fetchGbbOptions = (params) => api.get("/crm/equipment/gbb-options", { params }).then((r) => r.data);
export const rebuildMatches = () => api.post("/crm/equipment/rebuild-matches", {}).then((r) => r.data);
export const loadcalcLookup = (address) => api.get("/crm/loadcalc/lookup", { params: { address } }).then((r) => r.data);
export const loadcalcCompute = (b) => api.post("/crm/loadcalc/compute", b).then((r) => r.data);
export const retailQuote = (p) => api.post("/crm/pricebook/retail/quote", p).then((r) => r.data);
export const fetchCrmJobs = () => api.get("/crm/jobs").then((r) => r.data);
export const setJobPricebook = (id, book, note) =>
  api.post(`/crm/jobs/${id}/pricebook`, { book, note }).then((r) => r.data);
export const fetchPbAudit = () => api.get("/crm/audit").then((r) => r.data);
export const fetchStaff = () => api.get("/crm/staff").then((r) => r.data);
export const createStaff = (p) => api.post("/crm/staff", p).then((r) => r.data);
export const resetStaffCode = (id) => api.post(`/crm/staff/${id}/reset-code`).then((r) => r.data);
export const updateStaff = (id, p) => api.put(`/crm/staff/${id}`, p).then((r) => r.data);
export const fetchRoster = () => api.get("/crm/staff/roster").then((r) => r.data);

// ---- Phase 1: AI New Business / Prospecting Engine ----
export const prospectStats = () => api.get("/prospecting/stats").then((r) => r.data);
export const listProspects = (params = {}) => api.get("/prospecting", { params }).then((r) => r.data);
export const prospectSegments = () => api.get("/prospecting/segments").then((r) => r.data);
export const importProspects = (payload) => api.post("/prospecting/import", payload).then((r) => r.data);
export const discoverProspects = (payload) => api.post("/prospecting/discover", payload).then((r) => r.data);
export const residentialProfile = (payload) => api.post("/prospecting/residential-profile", payload).then((r) => r.data);
export const listResidentialProfiles = () => api.get("/prospecting/residential-profiles").then((r) => r.data);
export const qualifyProspect = (id) => api.post(`/prospecting/${id}/qualify`).then((r) => r.data);
export const qualifyBatch = (ids) => api.post("/prospecting/qualify-batch", ids ? { ids } : {}).then((r) => r.data);
export const draftOutreach = (id, channel = "email") => api.post(`/prospecting/${id}/draft-outreach`, { channel }).then((r) => r.data);
export const approvalQueue = () => api.get("/prospecting/approval-queue").then((r) => r.data);
export const approveProspect = (id) => api.post(`/prospecting/${id}/approve`).then((r) => r.data);
export const rejectProspect = (id) => api.post(`/prospecting/${id}/reject`).then((r) => r.data);
export const sendProspectOutreach = (id) => api.post(`/prospecting/${id}/send`).then((r) => r.data);
export const logProspectResponse = (id) => api.post(`/prospecting/${id}/log-response`).then((r) => r.data);
export const convertProspect = (id) => api.post(`/prospecting/${id}/convert`).then((r) => r.data);
export const updateProspect = (id, payload) => api.patch(`/prospecting/${id}`, payload).then((r) => r.data);
export const editProspectOutreach = (id, payload) => api.post(`/prospecting/${id}/edit-outreach`, payload).then((r) => r.data);
export const previewProspectOutreach = (id) => api.get(`/prospecting/${id}/preview`).then((r) => r.data);
export const deleteProspect = (id) => api.delete(`/prospecting/${id}`).then((r) => r.data);
export const qualifyAllNew = () => api.post("/prospecting/qualify-all").then((r) => r.data);
export const discoverSweep = (payload) => api.post("/prospecting/discover-sweep", payload).then((r) => r.data);
export const prospectRoi = (params = {}) => api.get("/prospecting/roi", { params }).then((r) => r.data);
export const jobAction = (id, action) => api.post(`/crm/jobs/${id}/action`, { action }).then((r) => r.data);
export const jobInvoice = (id, payload) => api.post(`/crm/jobs/${id}/invoice`, payload || {}).then((r) => r.data);
export const createCrmJob = (p) => api.post("/crm/jobs", p).then((r) => r.data);
export const dispatchJob = (id) => api.post(`/crm/jobs/${id}/dispatch`).then((r) => r.data);
export const invoicePaymentLink = (id) => api.post(`/crm/invoices/${id}/payment-link`).then((r) => r.data);
export const invoiceMarkPaid = (id, method) => api.post(`/crm/invoices/${id}/mark-paid`, { method }).then((r) => r.data);
export const sendInvoice = (id, email) => api.post(`/crm/invoices/${id}/send`, email ? { email } : {}).then((r) => r.data);
export const fetchCrmEquipment = (params) => api.get("/crm/equipment", { params }).then((r) => r.data);
export const saveCrmEquipment = (id, p) => (id ? api.put(`/crm/equipment/${id}`, p) : api.post("/crm/equipment", p)).then((r) => r.data);
export const fetchEqOptions = () => api.get("/crm/equipment-options").then((r) => r.data);
export const fetchDiscounts = () => api.get("/crm/discounts").then((r) => r.data);
export const saveDiscount = (id, p) => api.put(`/crm/discounts/${id}`, p).then((r) => r.data);
export const replacementQuote = (p) => api.post("/crm/equipment/replacement-quote", p).then((r) => r.data);


export const money2 = (n) => `$${(Number(n) || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
